import { createAction, props } from '@ngrx/store';

export const setPremiumValueAction = createAction(
  '[PREMIUMVALUE] Set Premium Value',
  props<{ premiumValue: number }>()
);